const sizes = {
  header: {
    height: 50
  }
}

export default sizes;


// WEBPACK FOOTER //
// ./src/styles/sizes.js